import { AritoIcon, AritoFormV2, BottomActionBarV2, DialogV2, HeaderTabsV2 } from '@/components/custom/erp';
import { BasicInfoTab, GeneralTab, OtherTab } from './tabs';
import { SearchFormValues, searchSchema } from '../schema';
import { useSearchFieldStates } from '../hooks';

interface InitialSearchDialogProps {
  onClose: () => void;
  onSearch: (values: SearchFormValues) => Promise<void>;
  initialValues: SearchFormValues;
  initialSearchFieldState?: BanHangRecord;
  onSaveSearchFieldState?: (state: BanHangRecord) => void;
}

export default function SearchDialog({
  onClose,
  onSearch,
  initialValues,
  initialSearchFieldState,
  onSaveSearchFieldState
}: InitialSearchDialogProps) {
  const searchFieldStates = useSearchFieldStates(initialSearchFieldState);
  const { state } = searchFieldStates;

  const handleSubmit = (data: SearchFormValues) => {
    const combinedData: SearchFormValues = {
      ...data,
      ngay_ct1: data.ngay_ct1,
      ngay_ct2: data.ngay_ct2,
      // Customer/Supplier related
      ma_nvbh: state.nhanVien?.uuid || '',
      ma_kh: state.khachHang?.uuid || '',
      nh_kh1: state.nhomKhachHang1?.uuid || '',
      nh_kh2: state.nhomKhachHang2?.uuid || '',
      nh_kh3: state.nhomKhachHang3?.uuid || '',
      rg_code: state.khuVuc?.uuid || '',

      // Other tab fields
      ma_gd: state.giaoDich?.uuid || ''
    };
    onSearch(combinedData);
    onSaveSearchFieldState?.(state);
  };

  const tabs = [
    {
      id: 'general',
      label: 'Thông tin chung',
      component: <GeneralTab searchState={searchFieldStates} />
    },
    {
      id: 'other',
      label: 'Khác',
      component: <OtherTab searchState={searchFieldStates} />
    }
  ];

  return (
    <DialogV2
      open={true}
      onClose={onClose}
      title='Bảng tổng hợp hóa đơn bán hàng hàng hóa, dịch vụ'
      titleIcon={<AritoIcon icon={699} />}
      maxWidth='lg'
    >
      <div className='flex size-full flex-col overflow-hidden'>
        <div className='flex-1 overflow-auto'>
          <AritoFormV2<SearchFormValues>
            schema={searchSchema}
            initialData={initialValues}
            onSubmit={handleSubmit}
            className='!static !w-full'
            hasAritoActionBar={false}
            headerFields={
              <div className='w-[820px] min-w-[800px] overflow-y-auto'>
                <BasicInfoTab />
                <HeaderTabsV2 tabs={tabs} />
              </div>
            }
            bottomBar={<BottomActionBarV2 mode='search' onClose={onClose} />}
          />
        </div>
      </div>
    </DialogV2>
  );
}
